<template>
  <div id="top">
    <div class="container" style="padding-top:100px">
      <div class="row">
        <div class="col-12">
          <h1>トランザクション手動「登録」フォーム</h1>
          <p>
            <router-link to="/addapter-admin/cancel"
              >削除の場合はこちらから</router-link
            >
          </p>
          <dl>
            <dt>トランザクションID</dt>
            <dd><input type="text" v-model="id" /></dd>
            <dt>価格</dt>
            <dd><input type="text" v-model="price" /></dd>
            <dt>税</dt>
            <dd><input type="text" v-model="tax" /></dd>
            <dt>商品</dt>
            <dd>
              <div v-for="(item, index) in items" :key="index">
                <h2
                  style="font-size:14px; margin:20px 0 5px; text-decoration:underline;"
                >
                  {{ index + 1 }}つ目の商品
                </h2>
                商品ID(postId)：<input type="text" v-model="item.id" /><br />
                商品名：<input type="text" v-model="item.name" /><br />
                個数：<input type="text" v-model="item.quantity" /><br />
                価格(単価)：<input type="text" v-model="item.price" />
              </div>
              <button type="button" @click="add_item()" style="margin-top:20px">
                + 商品追加
              </button>
            </dd>
            <div class="text-center">
              <p style="color:red;font-weight:bold;">
                ↓押した瞬間送信されるのでまじで注意です↓
              </p>
              <button type="button" @click="sent()" style="font-size:10px">
                送信
              </button>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cancel",
  data() {
    return {
      id: "",
      price: "",
      tax: "",
      items: [
        {
          id: "",
          name: "",
          quantity: 1,
          price: 0,
        },
      ],
    };
  },
  mounted() {
    //Global site tag (gtag.js) - Google Analytics
    // window.dataLayer = window.dataLayer || [];
    // this.gtag('js', new Date());
    // this.gtag('config', 'UA-65024675-3');
  },
  updated() {},
  methods: {
    // gtag
    gtag: function() {
      dataLayer.push(arguments);
    },
    sent: function() {
      gtag("event", "purchase", {
        transaction_id: this.id,
        affiliation: "銀のすぷーん予約サイト",
        value: this.price,
        tax: this.tax,
        items: this.items,
      });
      // console.log(
      //     {
      //         id: this.id,
      //         value: this.price,
      //         tax: this.tax,
      //         items: this.items
      //     }
      // )
      return;
    },
    add_item: function() {
      this.items.push({
        id: "",
        name: "",
        quantity: 1,
        price: 0,
      });
      return;
    },
  },
  head: {
    title: {
      inner: "キャンセルフォーム",
      separator: "|",
      complement: "銀のすぷーん予約サイト",
    },
    link: [
      {
        rel: "stylesheet",
        href:
          "https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css",
        integrity:
          "sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO",
        crossorigin: "anonymous",
      },
      {
        rel: "stylesheet",
        href: "https://use.fontawesome.com/releases/v5.3.1/css/all.css",
        integrity:
          "sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU",
        crossorigin: "anonymous",
      },
    ],
    // script: [
    //   {
    //     src: "https://www.googletagmanager.com/gtag/js?id=UA-65024675-3",
    //     async: "true",
    //   },
    // ],
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#top {
  background-color: #fdf5e6;
  padding-top: 70px;
  padding-bottom: 70px;
  font-family: 游明朝, "Yu Mincho", YuMincho, "Hiragino Mincho ProN", HGS明朝E,
    メイリオ, Meiryo, serif;
}
.btn_icon {
  img {
    max-width: 30px;
  }
}
.btn_other {
  margin: 30px 0 40px;
  background: #0d446f !important;
}
.btn_external {
  margin-top: 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  a {
    display: block;
    text-align: center;
    background: #0d446f !important;
    color: #fff;
    padding: 1rem 0;
    width: 45%;
    border-radius: 5px;
    &:hover {
      text-decoration: none;
      opacity: 0.8;
    }
  }
}
.span {
  font-weight: bold;
}
.topMainImg {
  margin-top: 80px;
  padding: 0 15px;
  @media (max-width: 767.98px) {
    margin-top: 70px;
  }
  &__img {
    max-width: 100%;
  }
}
.bg-blue {
  background: #0d446f;
  color: #fff;
  padding: 5px 20px;
  border-radius: 50px;
  font-size: 14px;
  margin-bottom: 10px;
  @media (max-width: 991.98px) {
    // width: 80%;
    margin: auto;
    margin-bottom: 10px;
  }
}
.c-blue {
  font-size: 36px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: normal;
  text-align: center;
  color: #03365b;
  font-style: italic;
}
.introduction {
  padding: 0 15px;
  .text1 {
    text-align: left;
  }
  .telInfo {
    text-align: center;
    &__time {
      font-size: 15px;
      font-weight: 500;
      line-height: 1.53;
      color: #333333;
      text-align: center;
    }
  }
}
.caution {
  border-radius: 5px;
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
  margin: 0 15px;
  padding: 0 15px;
  &__text1 {
    color: #c65c5c;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.28;
    margin-top: 17px;
    @media (max-width: 575.98px) {
      font-size: 16px;
    }
  }
  &__text2 {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.64;
    text-align: left;
    color: #333333;
  }
}
.reservationTitle {
  font-size: 21px;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
  color: #ae952f;
  margin-top: 30px;
  margin-bottom: 42px;
}
.iconCntainer {
  padding: 0 15px;
  .iconBox {
    position: relative;
    border-radius: 5px;
    background-color: #f6f6f6;
    border: solid 1px #eeeeee;
    min-height: 130px;
    .number {
      position: absolute;
      top: -10px;
      left: 50%;
      margin-left: -10px;
      font-size: 36px;
      font-weight: 500;
      line-height: 0.64;
      text-align: center;
      color: #0d446f;
    }
    p {
      text-align: center;
      padding: 0 20px;
      margin-top: 40px;
    }
    .icon3 {
      margin-bottom: 5px;
    }
    &__desc {
      margin-top: 15px;
      margin-bottom: 30px;
    }
  }
}
.btn {
  position: relative;
  background-color: #831f17;
  color: #fff;
  display: block;
  padding-top: 20px;
  padding-bottom: 20px;
  font-family: 游明朝, "Yu Mincho", YuMincho, "Hiragino Mincho ProN", HGS明朝E,
    メイリオ, Meiryo, serif;
  font-size: 20px;
  line-height: 1.15;
  text-align: center;
  color: #ffffff;
  &:hover {
    opacity: 0.7;
  }
  i {
    position: absolute;
    top: 50%;
    right: 30px;
    margin-top: -0.6em;
    font-size: 20px;
    line-height: 1.15;
    font-weight: bold;
  }
}
//電話をかけるのボタン
#telBtn {
  &:hover {
    opacity: 0.7;
    text-decoration: none;
  }
}
//サクリスタンプレゼントメッセージ
.presentMsg {
  border: 1px #ecb2cb dashed;
  padding: 15px 10px;
  border-radius: 10px;
  line-height: 2;
}
// sp時に下部に固定
.btn_reserve {
  @media (max-width: 575.98px) {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    .btn {
      margin: 0 0 0 0;
    }
  }
}

// ドメイン拒否の注意書き
.domeinNotice {
  border-radius: 5px;
  background-color: #f6f6f6;
  border: solid 1px #eeeeee;
  padding: 15px;
  margin-top: 50px;
  &__ttl {
    color: #03365b;
    font-weight: bold;
    font-size: 20px;
  }
  &__txt {
    font-size: 14px;
  }
  &__subTtl {
    font-size: 16px;
    color: #03365b;
    border: #03365b 1px solid;
    display: inline-block;
    padding: 5px 15px;
  }
  .list {
    margin-top: 10px;
    dt {
      background: #0d446f;
      display: inline;
      color: #fff;
      padding: 4px 10px;
      border-radius: 5px;
      font-size: 15px;
    }
    dd {
      margin-top: 7px;
      font-size: 14px;
    }
  }
}
</style>
